import { useMemo } from "react";
import { PASSWORD_RULES } from "../constants.js";
export function validatePassword(password) {
    const hasMinLength = password.length >= PASSWORD_RULES.minLength;
    const hasUppercase = /\p{Upper}/u.test(password);
    const hasLowercase = /\p{Lower}/u.test(password);
    const hasDigit = /\p{Nd}/u.test(password);
    return {
        isValid: hasMinLength && hasUppercase && hasLowercase && hasDigit,
        hasMinLength,
        hasUppercase,
        hasLowercase,
        hasDigit
    };
}
export function usePasswordValidation(password) {
    return useMemo(()=>validatePassword(password), [
        password
    ]);
}

//# sourceMappingURL=usePasswordValidation.js.map